import { ProductFrontMatter } from '@prishapolicy/markdown';
import React from 'react';

export const ProductWriteUpContext = React.createContext<{
  frontMatter: ProductFrontMatter;
  // setActiveSection: Dispatch<SetStateAction<string>>;
} | null>(null);

export default ProductWriteUpContext;
